import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { Subscription } from 'rxjs';
import { SignUpService } from 'src/app/shared/services/auth-service/sign-up.service';

@Component({
    selector: 'app-sign-up-acknowledge',
    templateUrl: './sign-up-acknowledge.component.html',
    styleUrls: ['./sign-up-acknowledge.component.scss'],
})
export class SignUpAcknowledgeComponent implements OnInit {
    options: AnimationOptions = {
        path: '/assets/images/reset_link_sent.json',
    };
    subscription: Subscription;
    constructor(private signUpService: SignUpService) {}
    eMail: any;

    ngOnInit(): void {
        this.subscription = this.signUpService.userEmail.subscribe((data) => {
            this.eMail = data;
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
